import { Grid, Typography } from '@mui/material';
import InLineEditTextField from '../../../components/common/InLineEditTextField';
import React from 'react';
import useAuth from '../../../hooks/useAuth';
import { useMutation } from '@apollo/client';
import { updateOrganizationAccount } from 'vendor-marketplace-shared-library';
import { UPDATE_ORGANIZATION_ACCOUNT } from '../../../error-messages';
import useAlert from '../../../hooks/useAlert';

export default function OrganizationUpdateForm() {
  const alert = useAlert();

  const { userQuery } = useAuth();

  const [updateOrganization] = useMutation(updateOrganizationAccount, {
    refetchQueries: ['me'],
    onError: () => {
      alert.setAlert({ severity: 'error', message: UPDATE_ORGANIZATION_ACCOUNT });
    },
  });

  const onUpdate = async (organizationName: string) => {
    await updateOrganization({
      variables: {
        id: userQuery.data?.me.organizationAccount.id,
        input: {
          name: organizationName,
        },
      },
    });
  };

  return (
    <Grid container direction={'column'} spacing={2} sx={styles.mainContainer}>
      <Grid item>
        <Typography variant={'h6'}>Organization Information</Typography>
      </Grid>
      <Grid item>
        <InLineEditTextField
          content={userQuery.data?.me.organizationAccount.name || ''}
          textVariant={'h4'}
          onSave={value => onUpdate(value)}
        />
      </Grid>
    </Grid>
  );
}

const styles = {
  mainContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
};
